import { Component, OnDestroy,OnInit } from '@angular/core';
import { MatDialogRef,MAT_DIALOG_DATA } from '@angular/material/dialog';
import { fuseAnimations } from '@fuse/animations';
import { Subject } from 'rxjs';
import { MatButton, MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DatePipe, NgClass, NgTemplateOutlet } from '@angular/common';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { RouterLink } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDividerModule } from '@angular/material/divider';
import { MatToolbarModule } from '@angular/material/toolbar';

@Component({
  selector: 'modal-accept-terms',
  templateUrl: './accept-terms-and-condition.component.html',
  styleUrls: ['./accept-terms-and-condition.component.scss'],
  animations: fuseAnimations,
})

export class AcceptTermsAndConditionComponent implements OnDestroy {

  isTermsAndConditionAccepted:boolean=false;
  
  private unsubscribeAll: Subject<any>;

  

  /**
   * Constructor
   *
   * @param {FuseConfigService} _fuseConfigService
   * @param {FormBuilder} _formBuilder
   */
  constructor(
    public matDialogRef: MatDialogRef<AcceptTermsAndConditionComponent>,
    private snb: MatSnackBar
  ) {
      this.unsubscribeAll = new Subject();
  }

  onChangeAccept(event) {
    this.isTermsAndConditionAccepted = event.checked;
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  
  /***
   * On Destroy
   */
  ngOnDestroy(): void {
    this.unsubscribeAll.next("");
    this.unsubscribeAll.complete();
  }
}
